<template>
  <span
    v-if="display"
    class="rank"
  >Rank {{ format(rank) }}/{{ format(total) }}</span>
</template>

<script>
export default {
  name: 'RareChartRank',
  props: {
    total: {
      type: Number,
      required: true,
    },
    rank: {
      type: Number,
      required: true,
    },
    display: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    format(data) {
      return (this.total === 0 && this.rank === 0 ? '-' : data);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@/css/global.scss";

  .rank {
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: 1px;
    color: $light-text;
  }

</style>
